export default {
    SUBMIT_FORM: "SUBMIT_FORM",
    SUBMIT_FORM_ERROR: "SUBMIT_FORM_ERROR",
    SUBMIT_FORM_SUCCESS: "SUBMIT_FORM_SUCCESS",
    CLEAR_SUBMIT_FORM: "CLEAR_SUBMIT_FORM"
};